import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "block h-12 mb-10",
  src: "/media/logos/logo-full-dark.svg",
  alt: "Workflow"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl leading-10 font-extrabold mt-6" }, [
  /*#__PURE__*/_createTextVNode(" Get "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500" }, "better, faster, smarter"),
  /*#__PURE__*/_createTextVNode(" commercial property financing. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-base leading-6 font-normal text-gray-500 mt-3" }, [
  /*#__PURE__*/_createTextVNode(" We're making commercial property financing easier. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Click the button below to get started. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowNarrowRightIcon = _resolveComponent("ArrowNarrowRightIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("a", {
      href: "#start",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('nextStep', { showForm: true })), ["prevent"])),
      class: "flex items-center text-base leading-6 font-medium text-sky-300 mt-10"
    }, [
      _createTextVNode(" Get started "),
      _createVNode(_component_ArrowNarrowRightIcon, { class: "w-4 h-4 ml-2" })
    ])
  ]))
}